import React from 'react';

import R2Image from '@/components/ui/R2Image';
import RichText from '@/components/ui/RichText/RichText';

import type { CardLabels } from '../../types';

const BOLD_PRICE_PATTERN = /^(.*?)(\*\*(.+?)\*\*)(.*)$/;

interface FlatTestsListProps {
  tests: string[];
  descriptionText?: string;
  cardOpen: boolean;
  labels: CardLabels;
}

export default function FlatTestsList({
  tests,
  descriptionText,
  cardOpen,
  labels,
}: FlatTestsListProps): React.ReactElement {
  if (descriptionText) {
    return (
      <RichText styles={labels.descriptionText?.styles}>
        {descriptionText}
      </RichText>
    );
  }

  return (
    <ul className="text-text-list font-regular space-y-1.5 text-base">
      {tests.map((test, i) => {
        const match = test.match(BOLD_PRICE_PATTERN);
        return (
          <li
            key={i}
            className={`flex items-start gap-2 ${i >= 2 && !cardOpen ? 'hidden' : ''}`}
          >
            <R2Image
              path="/images/healthpackages/check-icon.svg"
              alt="check"
              width={20}
              height={20}
              className="shrink-0 object-contain"
            />
            {match ? (
              <div className="flex w-full items-end justify-between">
                <p className="text-body text-text-body whitespace-pre-line">
                  {match[1]}
                  {match[4]}
                </p>
                <strong className="text-theme-primary ml-2 shrink-0">
                  {match[3]}
                </strong>
              </div>
            ) : (
              <RichText
                styles={{
                  em: 'text-[12px] not-italic',
                  p: 'text-body text-text-body whitespace-pre-line',
                }}
              >
                {test}
              </RichText>
            )}
          </li>
        );
      })}
    </ul>
  );
}
